import { FC } from "react";

import { TLatLngTuple } from "@ryde/shared";

import { MapLibrePolylineMapLayers } from "./maplibre-polyline-map-layers";
import { MapLibrePolylineToolbar } from "./maplibre-polyline-toolbar";
import { useMapLibrePolylineEdit } from "./use-maplibre-polyline-edit";

interface IMapLibrePolylineEditProps {
  positions: TLatLngTuple[];
  colorValue: string;
  onDrawStart?: () => void;
  onDrawEnd?: (newPositionsUrl: string) => void;
  onDrawingStateChange?: (
    isDrawing: boolean,
    addPointCallback?: (lat: number, lng: number) => void,
  ) => void;
}

/**
 * Course polyline draw/edit on MapLibre. Leaflet twin: `PolylineEdit` (kept for backup). All state and map
 * wiring live in `useMapLibrePolylineEdit`; this component only hands the result to the layers and the toolbar.
 */
export const MapLibrePolylineEdit: FC<IMapLibrePolylineEditProps> = ({
  positions,
  colorValue,
  onDrawStart,
  onDrawEnd,
  onDrawingStateChange,
}) => {
  const state = useMapLibrePolylineEdit({
    positions,
    onDrawStart,
    onDrawEnd,
    onDrawingStateChange,
  });

  return (
    <>
      <MapLibrePolylineMapLayers
        isEditing={state.isEditing}
        isDrawing={state.isDrawing}
        isDeletePointMode={state.isDeletePointMode}
        finalPositions={state.finalPositions}
        drawingPoints={state.drawingPoints}
        colorValue={colorValue}
        onEditedPositionsChange={state.handleEditedPositionsChange}
      />

      <MapLibrePolylineToolbar state={state} />
    </>
  );
};
